var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  var BLANK = '',
  checked = "checked=checked";
  let { checkboxes } = options;

__p+='\n\n<div class="row gutter-xs">\n  ';
 checkboxes.forEach(function (half) { 
__p+='\n    <div class="col-xxs-6">\n      <div class="filter-selection-list">\n        ';
 half.forEach(function (item) { 
__p+='\n          <div class="checkbox checkbox-primary">\n            <input id="nearby-checkbox-'+
((__t=( item.id ))==null?'':__t)+
'" value="'+
((__t=( item.id ))==null?'':__t)+
'" type="checkbox" name="checkbox-nearby-areas-'+
((__t=( item.id ))==null?'':__t)+
'" '+
((__t=( item.checked ? checked : BLANK ))==null?'':__t)+
'>\n            <label for="nearby-checkbox-'+
((__t=( item.id ))==null?'':__t)+
'"><span class="ellipsis">'+
((__t=( item.label ))==null?'':__t)+
'</span></label>\n          </div>\n        ';
 }); 
__p+='\n      </div>\n    </div>\n  ';
 }); 
__p+='\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/nearby-areas/checkboxes.jst.ejs